
export class PublicoAlvo {
    id: number;
    descricao: string;
    idUsuarioAplicacao: number;
	idInstituicao: number;
}